export const en = {
  nav: {
    dashboard: 'Dashboard',
    marketplace: 'Marketplace',
    administration: 'Administration',
    profile: 'Profile',
    logout: 'Sign out',
  },
  marketplace: {
    eyebrow: 'Catalog',
    search: 'Search catalog…',
    empty: {
      noResults: {
        eyebrow: 'No results',
        title: 'Nothing matches that filter.',
        body: 'Try clearing your search or category filter to see the full catalog.',
        action: 'Clear filters',
      },
      noAccess: {
        eyebrow: 'No access',
        title: "You're not in the right tenant for this.",
        body: 'Your current instance does not have access to any catalog entries. Switch to a different instance or request access from your administrator.',
        action: 'Switch instance',
      },
      fetchFailed: {
        eyebrow: "Couldn't load",
        title: "We couldn't reach the catalog service.",
        body: 'This is likely a transient issue. Please retry in a moment. If the problem persists, contact your administrator.',
        action: 'Retry',
      },
    },
  },
  tile: {
    cta: { order: 'Order', launch: 'Open', manage: 'Manage' },
    badge: { soon: 'Soon', private: 'Private' },
  },
  sidebar: {
    eyebrow: 'Categories',
    search: 'Search…',
    all: 'All',
  },
  orgSwitcher: {
    label: 'Switch instance',
    search: 'Search instances…',
  },
  subClient: {
    lifecycle: { provisioned: 'Provisioned', pending: 'Pending', suspended: 'Suspended' },
  },
  destructive: {
    cancel: 'Cancel',
    deleteConfirm: 'Delete',
    discard: 'Discard',
  },
  preview: {
    banner: 'Preview — state:',
  },
} as const;

export type Strings = typeof en;
